import {
  IParseResult,
  ParseResult,
  ValidateError,
  ValueType,
} from '../FormatterTypes';
import { BaseDisplayer } from '../Displayers/BaseDisplayer';

abstract class BaseValidator {
  protected constructor() {}

  abstract defaultParams(): string;
  abstract validate(value: ValueType, params?: string): IParseResult;

  maxLength(params: string = ''): number {
    return 0;
  }

  defaultValue(params: string = ''): ValueType {
    return '';
  }

  nextValue(
    value: ValueType,
    goForward: boolean = true,
    params: string = ''
  ): ValueType {
    return '';
  }

  errorMessage(
    value: ValueType,
    parseResult: IParseResult,
    displayer: BaseDisplayer,
    params: string = '',
    displayerParams: string = '',
    caption: string = '',
    preFix: string = ''
  ): string {
    let dText = '';
    if (displayer) {
      dText = displayer.display(value, true, displayerParams);
    } else {
      dText = String(value);
    }

    if (parseResult.result > ParseResult.OK) {
      return `Ogiltigt värde "${dText}" i ${caption}.`;
    } else if (parseResult.result < ParseResult.OK) {
      return `Kontrollera värdet "${dText}" i ${caption}.`;
    } else {
      return '';
    }
  }

  raiseError(
    value: ValueType,
    parseResult: IParseResult,
    displayer: BaseDisplayer,
    params: string = '',
    displayerParams: string = '',
    caption: string = '',
    sender: string = '',
    unitName: string = '',
    procName: string = ''
  ): void {
    if (parseResult.result > ParseResult.OK) {
      // Kan behöva lägga in mer info i error meddelandet, från delphi
      throw new ValidateError(
        this.errorMessage(
          value,
          parseResult,
          displayer,
          params,
          displayerParams,
          caption
        )
      );
    } else if (parseResult.result < ParseResult.OK) {
      throw new Error('Not implemented yet, BaseValidator.raiseError'); // GUIWarning
    }
  }

  checkValidate(
    value: ValueType,
    displayer: BaseDisplayer,
    params: string = '',
    displayerParams: string = '',
    caption: string = '',
    sender: string = '',
    unitName: string = '',
    procName: string = ''
  ) {
    let prcName = procName ? procName : typeof procName + '.checkValidate';
    this.raiseError(
      value,
      this.validate(value, params),
      displayer,
      params,
      displayerParams,
      caption,
      sender,
      unitName,
      prcName
    );
  }
}

export { BaseValidator };
